import React from 'react';
export const AboutSection = () => {
  return <section id="about" className="relative py-20 w-full overflow-hidden bg-[#080910]" data-id="element-10">
      {/* Background elements */}
      <div className="absolute inset-0 z-0" data-id="element-11">
        <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1550745165-9bc0b252726f?q=80&w=3270&auto=format&fit=crop')] opacity-5 bg-cover bg-center" data-id="element-12"></div>
      </div>
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-13">
        <div className="text-center mb-16" data-id="element-14">
          <h2 className="text-3xl md:text-4xl font-bold font-['Orbitron'] mb-4" data-id="element-15">
            About{' '}
            <span className="bg-gradient-to-r from-[#00E5FF] to-[#B721FF] text-transparent bg-clip-text" data-id="element-16">
              Nexoraq
            </span>
          </h2>
        </div>
        <div className="max-w-3xl mx-auto text-center" data-id="element-17">
          <p className="text-xl text-[#F5F5F5] mb-8 leading-relaxed" data-id="element-18">
            We are the architects of the next digital era. At Nexoraq, we
            believe that every groundbreaking app begins with a single thought —
            a moment of inspiration that deserves to be transformed into
            reality.
          </p>
          <p className="text-lg text-[#F5F5F5]/70 mb-12" data-id="element-19">
            Our team of visionary designers, engineers, and strategists work
            together to bridge the gap between imagination and implementation,
            creating digital experiences that don't just meet expectations —
            they redefine them.
          </p>
          <div className="flex flex-wrap justify-center gap-8" data-id="element-20">
            <div className="text-center" data-id="element-21">
              <div className="text-4xl font-bold font-['Orbitron'] bg-gradient-to-r from-[#00E5FF] to-[#B721FF] text-transparent bg-clip-text mb-2" data-id="element-22">
                150+
              </div>
              <p className="text-[#F5F5F5]/70" data-id="element-23">Apps Launched</p>
            </div>
            <div className="text-center" data-id="element-24">
              <div className="text-4xl font-bold font-['Orbitron'] bg-gradient-to-r from-[#00E5FF] to-[#B721FF] text-transparent bg-clip-text mb-2" data-id="element-25">
                98%
              </div>
              <p className="text-[#F5F5F5]/70" data-id="element-26">Client Satisfaction</p>
            </div>
            <div className="text-center" data-id="element-27">
              <div className="text-4xl font-bold font-['Orbitron'] bg-gradient-to-r from-[#00E5FF] to-[#B721FF] text-transparent bg-clip-text mb-2" data-id="element-28">
                12M+
              </div>
              <p className="text-[#F5F5F5]/70" data-id="element-29">App Downloads</p>
            </div>
          </div>
        </div>
      </div>
    </section>;
};